import styled from '@emotion/styled'
import { Box, Card, Chip, Tab, Tabs } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export const StyledCard = styled(Card)`
    padding: ${getPxAsRem(16)};
    border-radius: 8px;
    overflow: auto;
    height: ${getPxAsRem(270)};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
`

export const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(16)};
`

export const StyledTabs = styled(Tabs)`
    margin-bottom: ${getPxAsRem(8)};
`

export const StyledTab = styled(Tab)`
    flex: 1;
    min-width: 0;
    text-align: center;
    white-space: nowrap;
    font-size: ${getPxAsRem(12)};
`

export const ContactRow = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${getPxAsRem(8, 0)};
`

export const ContactChip = styled(Chip)``
